import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { CommonService } from '../../../services/common.service';
@Component({
  selector: 'app-inventory-list',
  templateUrl: './../../../templates/forms/modals/inventory-list.component.html',
})
export class InventoryListComponent implements OnInit {
  @Input()
  config: any;
  
  @Input()
  modalShow: boolean = true;

  @Input()
  bankDocsetup;
  
  @Input()
  negotiationNo;
  
  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;

  @Input()
  inventoryList = [];

  public searchFields: any[] = ['PI_ID'];
  public searchString;
  
  constructor(private commonService: CommonService,
    public langService: LangService) { }
  ngOnInit() {
    if(this.bankDocsetup == 'P'){
      this.commonService.getPiIdByNegoNo(this.negotiationNo)
      .subscribe(arg => { this.inventoryList = arg.body });
    }else{
      this.commonService.getSiIdByNegoNo(this.negotiationNo)
      .subscribe(arg => { this.inventoryList = arg.body });
    }
    
  }

}
